const KEY = "afterglow-atlas.v1.device-key";

function toHex(bytes: ArrayBuffer) {
  return Array.from(new Uint8Array(bytes), (b) => b.toString(16).padStart(2, "0")).join("");
}

export function getOrCreateDeviceKey() {
  const existing = localStorage.getItem(KEY);
  if (existing) return existing;
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  const key = toHex(bytes.buffer);
  localStorage.setItem(KEY, key);
  return key;
}

export async function getDeviceHash() {
  const key = getOrCreateDeviceKey();
  const digest = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(key));
  return toHex(digest).slice(0, 48);
}

export function rotateDeviceKey() {
  localStorage.removeItem(KEY);
  return getOrCreateDeviceKey();
}
